export const ColorType = {
    UNKNOWN: -1,
    GREYSCALE: 0,
    TRUECOLOUR: 2,
    INDEXED_COLOUR: 3,
    GREYSCALE_ALPHA: 4,
    TRUECOLOUR_ALPHA: 6,
};
export const CompressionMethod = {
    UNKNOWN: -1,
    DEFLATE: 0,
};
export const FilterMethod = {
    UNKNOWN: -1,
    ADAPTIVE: 0,
};
export const InterlaceMethod = {
    UNKNOWN: -1,
    NO_INTERLACE: 0,
    ADAM7: 1,
};
export const DisposeOpType = {
    NONE: 0,
    BACKGROUND: 1,
    PREVIOUS: 2,
};
export const BlendOpType = {
    SOURCE: 0,
    OVER: 1,
};
